import {
  Box,
  Typography,
  //  Button
} from '@material-ui/core';
import React from 'react';
import useFinanceHeader from '../../hooks/useFinanceHeader';

const BuzzHeader = () => {
  const { header, subHeader, component: HeaderComponent } = useFinanceHeader();
  return (
    <Box display="flex" flex={1} justifyContent="center" alignItems="center">
      <Box flex={1} flexGrow={1}>
        <Typography variant="h4" component="div">
          <Box fontWeight="fontWeightMedium">{header}</Box>
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          {subHeader}
        </Typography>
      </Box>
      <Box>
        <HeaderComponent />
      </Box>
    </Box>
  );
};

export default BuzzHeader;
